import { getPdf } from './states';

export const services = {
  getPdf,
};
